module.exports = __webpack_public_path__ + "static/media/background-blue.5d628fd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/background-blue.png
// module id = 540
// module chunks = 0